import * as React from 'react';

interface IProps {
  width?: number;
  color?: string;
}

export default (props: IProps) => {
  const {width, color} = props;

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3103 0C12.8484 0 11.3866 0.578042 10.2687 1.62402L2.30025 9.11104C-0.76675 12.0563 -0.76675 16.8183 2.30025 19.7911C5.36725 22.7363 10.326 22.7363 13.4217 19.7911L17.0047 16.3503L15.0269 14.451L11.7019 17.5615L11.4439 17.9193C9.46614 19.8186 6.25582 19.8186 4.27804 17.9193C2.32891 16.0475 2.38624 13.0197 4.27804 11.1204L12.2465 3.55083C13.3644 2.47732 15.2275 2.47732 16.3741 3.55083C17.4919 4.62433 17.4346 6.33094 16.3741 7.43197L9.20817 14.2308C8.92153 14.5061 8.43425 14.5061 8.11895 14.2308C7.83232 13.9556 7.83232 13.4876 8.11895 13.1849L8.29094 13.1023L10.8993 10.5149L8.92153 8.61558L6.14117 11.2856C4.76532 12.6068 4.76532 14.7814 6.14117 16.1026C7.51702 17.4238 9.78144 17.4514 11.1573 16.1026L18.3232 9.3863C20.5589 7.23929 20.5589 3.77104 18.3232 1.65155C17.2053 0.578042 15.7721 0.0275258 14.2816 0.0275258L14.3103 0Z"
        fill={color}
      />
    </svg>
  );
};
